// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { list, get, generate } from "./operations.js";
export type {
  BetaInsightsListOptionalParams,
  BetaInsightsGetOptionalParams,
  BetaInsightsGenerateOptionalParams,
} from "./options.js";
